export default {
  quotations: [],
  quotation: {},
  actions: [],
  statuses: [],
};
